import {
    USUARI_INICIALITZAR,
    USUARI_INTRODUCCIO_OMPLIR_DADES
} from '../../../../actions/actionTypes';

const ESTAT_INICIAL = true;

const esActiu = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {
        case USUARI_INICIALITZAR:
            return ESTAT_INICIAL;

        case USUARI_INTRODUCCIO_OMPLIR_DADES:
            return action.esActiu;

        default:
            return state;
    }
};

export default esActiu;



// WEBPACK FOOTER //
// ./src/reducers/usuari/formulari/dades/esActiu.js